import { convertSecondsToMinutes } from '@race-planner/unit-converters';

export const calculateSwimDistanceForPace = ({
    timeInSeconds,
    paceInSeconds
}) => {
    if (paceInSeconds === 0) {
        return 0;
    }

    return convertSecondsToMinutes(timeInSeconds) / convertSecondsToMinutes(paceInSeconds) * 100;
};
